// extracted by mini-css-extract-plugin
module.exports = {"root":"Empty-root-669fdc4fb7509635056a093bb9197971","text":"Empty-text-380a3852053bfe1f6c44281d715aab15"};